<app-nav></app-nav>

<main class="download-page">
  <section class="hero">
    <h1>Get Skip To My Loo</h1>
    <p class="tagline">Where to go when you gotta go.</p>
  </section>

  <section class="store-buttons">
    @if (hasAnyLink) {
      @if (appStoreUrl) {
        <button
          type="button"
          mat-raised-button
          color="primary"
          class="store-btn"
          (click)="open(appStoreUrl)"
        >
          <mat-icon>apple</mat-icon>
          Download on the App Store
        </button>
      }

      @if (testflightUrl) {
        <button
          type="button"
          mat-stroked-button
          class="store-btn"
          (click)="open(testflightUrl)"
        >
          <mat-icon>science</mat-icon>
          Join the iOS beta (TestFlight)
        </button>
      }

      @if (playStoreUrl) {
        <button
          type="button"
          mat-raised-button
          color="primary"
          class="store-btn"
          (click)="open(playStoreUrl)"
        >
          <mat-icon>android</mat-icon>
          Get it on Google Play
        </button>
      }
    } @else {
      <mat-card class="coming-soon">
        <mat-card-content>
          <mat-icon class="coming-icon">schedule</mat-icon>
          <h2>Coming soon to iOS and Android</h2>
          <p>
            We're putting the finishing touches on the apps. If you'd like an
            early look or want to be notified the moment we ship, drop us a
            line on the
            <a routerLink="/contact">contact page</a>.
          </p>
        </mat-card-content>
      </mat-card>
    }
  </section>
</main>

<app-footer></app-footer>
